import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'small';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg ${
        size === 'small' ? 'aspect-[3/4]' : 'aspect-[5/7]'
      }`}>
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 好看韩国漫画`}
          title={`${comic.title} - 韩漫在线免费阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 right-2">
          <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-accent-500 text-background-50'
              : 'bg-foreground-600 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-xs text-white/90 line-clamp-3">{comic.description}</p>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <div className="flex items-center gap-0.5">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-xs text-accent-500"></i>
            </div>
            <span className="text-xs text-foreground-600">{comic.rating}</span>
          </div>
          <span className="text-xs text-foreground-400">{comic.author}</span>
        </div>
      </div>
    </Link>
  );
}